/* Novara — componentes próprios sobre o Dawn 8 (sem dependências) */

/* ---------- nv-carousel ----------
   <nv-carousel data-per-d="3" data-per-m="1" data-gap-d="28" data-gap-m="16"
                data-loop data-autoplay="5" data-peek-m="0">
     <div class="nv-car__viewport"><div class="nv-car__track"> .nv-car__slide ... </div></div>
     [data-nv-prev] [data-nv-next] .nv-car__dots
   </nv-carousel>
   Loop = clona slides nas pontas e reposiciona sem animação. */
class NvCarousel extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.viewport = this.querySelector(this.constructor.viewportSel || '.nv-car__viewport');
    this.track = this.querySelector(this.constructor.trackSel || '.nv-car__track');
    if (!this.viewport || !this.track) return;
    if (this.prepare) this.prepare();
    this.slides = [...this.track.children];
    this.count = this.slides.length;
    if (!this.count) return;
    this.loop = this.hasAttribute('data-loop') && this.count > 1;
    this.index = 0;
    this.dotsWrap = null;
    this.mq = window.matchMedia('(min-width: 750px)');
    if (this.loop) this.cloneEnds();
    this.dotsWrap = this.querySelector('.nv-car__dots');
    this.buildDots();
    this.querySelectorAll('[data-nv-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1, true)));
    this.querySelectorAll('[data-nv-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1, true)));
    this.track.addEventListener('transitionend', () => this.fixLoop());
    this.bindSwipe();
    this.onResize = () => { this.layout(); this.go(this.index, false, true); };
    window.addEventListener('resize', this.onResize);
    this.mq.addEventListener('change', this.onResize);
    this.layout();
    this.go(0, false, true);
    this.startAutoplay();
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.stopAutoplay();
  }
  get desktop() { return this.mq.matches; }
  get per() { return parseFloat(this.desktop ? this.dataset.perD || 1 : this.dataset.perM || 1); }
  get gap() { return parseFloat(this.desktop ? this.dataset.gapD || 0 : this.dataset.gapM || 0); }
  get peek() { return parseFloat(this.desktop ? this.dataset.peekD || 0 : this.dataset.peekM || 0); }
  get pages() { return this.loop ? this.count : Math.max(1, Math.ceil(this.count - this.per + 1)); }
  cloneEnds() {
    const mk = (s) => { const c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.classList.add('nv-car__clone'); return c; };
    const tail = this.slides.map(mk), head = this.slides.map(mk);
    tail.forEach((c) => this.track.insertBefore(c, this.slides[0]));
    head.forEach((c) => this.track.appendChild(c));
    this.offset = this.count;
  }
  layout() {
    const vcs = getComputedStyle(this.viewport);
    const w = this.viewport.clientWidth - parseFloat(vcs.paddingLeft) - parseFloat(vcs.paddingRight);
    const per = this.per, gap = this.gap, peek = this.peek;
    this.slideW = (w - peek - gap * (Math.ceil(per) - 1)) / per;
    [...this.track.children].forEach((s) => { s.style.width = this.slideW + 'px'; s.style.flex = '0 0 ' + this.slideW + 'px'; });
    this.track.style.gap = gap + 'px';
    const forced = this.hasAttribute(this.desktop ? 'data-static-d' : 'data-static-m');
    this.isStatic = forced || (!this.loop && this.count <= per);
    this.toggleAttribute('data-static', this.isStatic);
  }
  pos(i) {
    const x = -((i + (this.loop ? this.offset : 0)) * (this.slideW + this.gap));
    /* último slide encosta na direita quando há espiada (sem espaço vazio no fim) */
    return (!this.loop && this.peek && i > 0 && i === this.pages - 1) ? x + this.peek : x;
  }
  go(i, user, instant) {
    if (this.isStatic) { this.index = 0; this.track.style.transform = ''; this.updateDots(); this.adapt(); return; }
    if (!this.loop) i = Math.max(0, Math.min(i, this.pages - 1));
    this.index = i;
    this.track.style.transition = instant ? 'none' : '';
    this.track.style.transform = `translate3d(${this.pos(i)}px,0,0)`;
    if (instant) { void this.track.offsetWidth; this.track.style.transition = ''; }
    this.updateDots();
    this.adapt();
    if (user) { this.stopAutoplay(); this.startAutoplay(); }
  }
  adapt() {
    const on = this.hasAttribute(this.desktop ? 'data-adaptive-d' : 'data-adaptive-m');
    if (!on) { this.viewport.style.height = ''; return; }
    const all = [...this.track.children];
    const cur = all[this.index + (this.loop ? this.offset : 0)];
    if (cur) this.viewport.style.height = cur.offsetHeight + 'px';
  }
  fixLoop() {
    if (!this.loop) return;
    if (this.index >= this.count || this.index < 0) {
      this.index = ((this.index % this.count) + this.count) % this.count;
      this.go(this.index, false, true);
    }
  }
  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    for (let i = 0; i < this.pages; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'nv-car__dot';
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', () => this.go(i, true));
      this.dotsWrap.appendChild(b);
    }
  }
  updateDots() {
    if (!this.dotsWrap) return;
    const cur = this.loop ? ((this.index % this.count) + this.count) % this.count : this.index;
    [...this.dotsWrap.children].forEach((d, i) => d.classList.toggle('is-active', i === cur));
  }
  startAutoplay() {
    const s = parseFloat(this.dataset.autoplay || 0);
    if (!s || this._timer || (window.Shopify && Shopify.designMode)) return;
    this._timer = setInterval(() => { if (!this.isStatic) this.go(this.index + 1); }, s * 1000);
  }
  stopAutoplay() { clearInterval(this._timer); this._timer = null; }
  bindSwipe() {
    let x0 = null, y0 = null, base = 0, moved = false;
    this.viewport.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; y0 = e.clientY; base = this.pos(this.index); moved = false;
    });
    window.addEventListener('pointermove', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved && Math.abs(e.clientY - y0) > Math.abs(dx)) { x0 = null; return; }
      moved = true;
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${base + dx}px,0,0)`;
    });
    const end = (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null;
      this.track.style.transition = '';
      if (moved && Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
      else if (moved) this.go(this.index);
    };
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    this.viewport.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
}
if (!customElements.get('nv-carousel')) customElements.define('nv-carousel', NvCarousel);

/* ---------- nv-tabs (abas com fundo deslizante) ---------- */
class NvTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('.nv-tabs__btn')];
    this.panels = [...this.querySelectorAll('.nv-tab')];
    this.pill = this.querySelector('.nv-tabs__pill');
    this.buttons.forEach((b) => b.addEventListener('click', () => this.select(+b.dataset.index)));
    this.onResize = () => this.movePill(false);
    window.addEventListener('resize', this.onResize);
    requestAnimationFrame(() => this.movePill(false));
    if (document.fonts) document.fonts.ready.then(() => this.movePill(false));
  }
  disconnectedCallback() { window.removeEventListener('resize', this.onResize); }
  select(i) {
    this.buttons.forEach((b, j) => { b.classList.toggle('is-active', j === i); b.classList.toggle('content-tab-button--active', j === i); b.setAttribute('aria-selected', j === i); });
    this.panels.forEach((p, j) => {
      p.classList.toggle('is-active', j === i);
      p.classList.toggle('content-tab--active', j === i);
      p.querySelectorAll('video').forEach((v) => { if (j === i && v.autoplay) v.play().catch(() => {}); else v.pause(); });
    });
    this.movePill(true);
  }
  movePill(animate) {
    const b = this.buttons.find((x) => x.classList.contains('is-active'));
    if (!b || !this.pill) return;
    this.pill.style.transition = animate ? '' : 'none';
    this.pill.style.width = b.offsetWidth + 'px';
    this.pill.style.height = b.offsetHeight + 'px';
    this.pill.style.transform = `translate(${b.offsetLeft}px, ${b.offsetTop}px)`;
    if (!animate) { void this.pill.offsetWidth; this.pill.style.transition = ''; }
  }
}
if (!customElements.get('nv-tabs')) customElements.define('nv-tabs', NvTabs);

/* ---------- nv-compare (antes / depois) ---------- */
class NvCompare extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('.comparison-slider__input');
    if (!input) return;
    const set = () => this.style.setProperty('--percent', input.value + '%');
    input.addEventListener('input', set);
    set();
  }
}
if (!customElements.get('nv-compare')) customElements.define('nv-compare', NvCompare);

/* ---------- voltar ao topo ---------- */
document.addEventListener('DOMContentLoaded', () => {
  const b = document.querySelector('.nv-to-top');
  if (!b) return;
  const on = () => b.classList.toggle('is-visible', window.scrollY > 600);
  window.addEventListener('scroll', on, { passive: true });
  on();
  b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
});

/* ---------- cart-drawer (Novara) ---------- */
class NvCartDrawer extends HTMLElement {
  connectedCallback() {
    if (this._init) return; this._init = true;
    this.addEventListener('click', (e) => this.onClick(e));
    this.addEventListener('change', (e) => { const i = e.target.closest('[data-nv-qty-input]'); if (i) this.change(i.closest('.cart-item').dataset.line, Math.max(0, parseInt(i.value || 0, 10))); });
    this.addEventListener('keyup', (e) => { if (e.code === 'Escape') this.close(); });
    document.addEventListener('click', (e) => {
      const icon = e.target.closest('#cart-icon-bubble');
      if (icon && !window.location.pathname.startsWith(window.nvRoutes ? window.nvRoutes.cart_url : '/cart')) { e.preventDefault(); this.open(icon); }
    });
  }
  get sectionId() { return this.dataset.section || 'nv-cart-drawer'; }
  open(trigger) {
    if (trigger) this.setActiveElement(trigger);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden', 'nv-cart-open');
    setTimeout(() => { const f = this.querySelector('.drawer__inner'); f && f.focus({ preventScroll: true }); }, 50);
  }
  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden', 'nv-cart-open');
    if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
  }
  setActiveElement(el) { this.activeElement = el; }
  getSectionsToRender() { return [{ id: this.sectionId, selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  renderContents(parsed, keepOpen) {
    const sections = parsed.sections || parsed;
    const html = sections[this.sectionId];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      if (fresh) { this.querySelector('.drawer__inner').replaceWith(fresh.querySelector('.drawer__inner')); this.classList.toggle('is-empty', fresh.classList.contains('is-empty')); }
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section') || doc.body;
      bubble.innerHTML = inner.innerHTML;
    }
    if (!keepOpen) setTimeout(() => this.open());
    else this.open();
  }
  async post(url, body) {
    this.classList.add('nv-loading');
    try {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: this.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname }) });
      const data = await res.json();
      if (data.status && data.description) { alert(data.description); return; }
      this.renderContents(data, true);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer' });
    } catch (e) { console.error(e); }
    finally { this.classList.remove('nv-loading'); }
  }
  change(line, quantity) { return this.post(`${window.routes.cart_change_url}.js`, { line: parseInt(line, 10), quantity }); }
  onClick(e) {
    if (e.target.closest('[data-nv-close]')) { e.preventDefault(); this.close(); return; }
    const q = e.target.closest('[data-nv-qty]');
    if (q) { const item = q.closest('.cart-item'); const input = item.querySelector('[data-nv-qty-input]'); this.change(item.dataset.line, Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.nvQty, 10))); return; }
    const r = e.target.closest('[data-nv-remove]');
    if (r) { this.change(r.closest('.cart-item').dataset.line, 0); return; }
    const u = e.target.closest('[data-nv-upsell]');
    if (u) { e.preventDefault(); this.post(`${window.routes.cart_add_url}.js`, { items: [{ id: parseInt(u.dataset.nvUpsell, 10), quantity: 1 }] }); }
  }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', NvCartDrawer);

/* ---------- timer de reserva (persiste na sessão) ---------- */
class NvTimer extends HTMLElement {
  connectedCallback() {
    const dur = parseInt(this.dataset.duration || 300, 10) * 1000;
    let end = parseInt(sessionStorage.getItem('nv-cart-timer') || 0, 10);
    if (!end || end < Date.now()) { end = Date.now() + dur; try { sessionStorage.setItem('nv-cart-timer', end); } catch (e) {} }
    const m = this.querySelector('[data-m]'), s = this.querySelector('[data-s]');
    const tick = () => {
      let left = Math.max(0, end - Date.now());
      if (left === 0) { end = Date.now() + dur; try { sessionStorage.setItem('nv-cart-timer', end); } catch (e) {} left = dur; }
      const sec = Math.floor(left / 1000);
      m.textContent = String(Math.floor(sec / 60)).padStart(2, '0');
      s.textContent = String(sec % 60).padStart(2, '0');
    };
    tick(); this._t = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
}
if (!customElements.get('nv-timer')) customElements.define('nv-timer', NvTimer);

/* ---------- splide-component (compatível com a marcação dos blocos Liquid personalizados) ---------- */
class NvSplide extends NvCarousel {
  static get viewportSel() { return '.splide__track'; }
  static get trackSel() { return '.splide__list'; }
  prepare() {
    const d = this.dataset, sp = this.querySelector('.splide') || this;
    this.dataset.perD = d.slidesDesktop || 1;
    this.dataset.perM = d.slidesMobile || 1;
    this.dataset.gapD = d.gapDesktop || 0;
    this.dataset.gapM = d.gapMobile || 0;
    if (d.type === 'loop') this.setAttribute('data-loop', '');
    this.dataset.autoplay = d.autoplay === 'true' ? (d.autoplaySpeed || 5) : 0;
    const cls = sp.className;
    const arrowsD = /desktop-arrows-sides/.test(cls), arrowsM = /mobile-arrows-sides/.test(cls);
    const dotsD = !/desktop-dots-hidden/.test(cls), dotsM = !/mobile-dots-hidden/.test(cls);
    this.classList.toggle('nv-sp--arrows-d', arrowsD); this.classList.toggle('nv-sp--arrows-m', arrowsM);
    this.classList.toggle('nv-sp--dots-d', dotsD); this.classList.toggle('nv-sp--dots-m', dotsM);
    this.classList.toggle('nv-sp--outside', /arrows-outside/.test(cls));
    const chev = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" aria-hidden="true"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"/></svg>';
    if (arrowsD || arrowsM) {
      const mk = (dir) => { const b = document.createElement('button'); b.type = 'button'; b.className = `splide__arrow splide__arrow--${dir} nv-car__arrow nv-car__arrow--${dir} color-${d.arrowsColor || 'inverse'}`; b.setAttribute(dir === 'prev' ? 'data-nv-prev' : 'data-nv-next', ''); b.innerHTML = chev; return b; };
      sp.appendChild(mk('prev')); sp.appendChild(mk('next'));
    }
    if (dotsD || dotsM) { const u = document.createElement('div'); u.className = `splide__pagination nv-car__dots color-${d.dotsColor || 'inverse'}`; sp.appendChild(u); }
    if (d.sidePaddingMobile) this.style.setProperty('--nv-sp-pad-m', d.sidePaddingMobile + 'px');
    if (d.sidePaddingDesktop) this.style.setProperty('--nv-sp-pad-d', d.sidePaddingDesktop + 'px');
  }
}
if (!customElements.get('splide-component')) customElements.define('splide-component', NvSplide);
